'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import Fallback from '../components/Fallback';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error, {
      tags: {
        component: 'error-boundary',
        crash: 'true',
        environment: process.env.NEXT_PUBLIC_ENV || 'production',
      },
      extra: {
        digest: error?.digest,
        message: error?.message,
        stack: error?.stack,
        name: error?.name,
        pathname: window?.location?.pathname,
        timestamp: new Date().toISOString(),
      },
      level: 'error',
    });
  }, [error]);

  return <Fallback error={error} resetErrorBoundary={reset} />;
}
